export default __webpack_public_path__ + "static/media/davinta-logo.8d7e4503.svg";